var $;

$ = window.jQuery;

require('./plugin');

$(document).on('submit.button.data-api', function(event) {
  if ($.rails != null) {
    return;
  }
  return setTimeout(function() {
    return $('[data-disable-with]', event.target).each(function() {
      return $(this).button('disable');
    });
  }, 13);
});

$.plugin('button', {
  defaults: {
    disableWithText: 'Submitting...'
  },
  dataOptionMapping: {
    disableWithText: 'data-disable-with'
  },
  init: function() {
    this.textMethod = this.element.is('button') ? 'html' : 'val';
    this.disableWithText = this.options['disableWithText'];
    return this.enableWithText = this.element[this.textMethod]();
  },
  disable: function() {
    this.element[this.textMethod](this.disableWithText);
    return this.element.prop('disabled', true);
  },
  enable: function() {
    this.element[this.textMethod](this.enableWithText);
    return this.element.prop('disabled', false);
  }
});
